import { Pipe, PipeTransform } from '@angular/core';
import { NgAvestaTranslateService } from 'ng-avesta-translate';

@Pipe({
  name: 'totalstring'
})
export class TotalstringPipe implements PipeTransform {

  constructor(private tn: NgAvestaTranslateService) { }

  private thaiNum = ['ศูนย์', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];
  private thaiUnit = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'];

  private enNum = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
    'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  private enTens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  private enScale = ['', ' thousand', ' million', ' billion', ' trillion'];

  transform(value: any, args?: any): any {
    if (isNaN(value) || value === null) { return value; }

    const splitArray = value.toString().split('.');

    // อ่านตามภาษาที่เลือกอยู่ (TH = ไทย, นอกนั้นใช้อังกฤษ)
    let language: any = '';
    try { language = this.tn.actionLanguage; } catch (e) { language = ''; }
    if (String(language || 'TH').toUpperCase() != 'TH') {
      return this.transformEnglish(splitArray);
    }

    const bahtArray = splitArray[0].replace('-', '').split('').reverse().map((val: any) => parseInt(val, 10));
    if (splitArray.length === 1) {
      const resultBahtArray = [];
      resultBahtArray.push('บาทถ้วน')
      const resultBaht = this.transformArray(bahtArray);
      resultBahtArray.push(resultBaht.reverse().join(''));
      return resultBahtArray.reverse().join('');
    }
    else {
      const resultBahtArray = [];
      resultBahtArray.push('บาท');
      const resultBaht = this.transformArray(bahtArray);
      resultBahtArray.push(resultBaht.reverse().join(''));
      const satangArray = splitArray[1].replace('-', '').split('').reverse().map((val: any) => parseInt(val, 10));
      const resultSatangArray = [];
      resultSatangArray.push('สตางค์');
      const resultSatang = this.transformArray(satangArray).join('');
      resultSatangArray.push(resultSatang);
      return resultBahtArray.reverse().join('') + resultSatangArray.reverse().join('');
    }



  }

  // อ่านจำนวนเงินเป็นภาษาอังกฤษ เช่น 264573.55 -> Two hundred sixty-four thousand ... Baht and fifty-five Satang
  private transformEnglish(splitArray: any) {
    const baht = parseInt(splitArray[0].replace('-', ''), 10) || 0;
    const satang = splitArray.length > 1 ? parseInt(splitArray[1].replace('-', '').padEnd(2, '0').slice(0, 2), 10) : 0;

    const text = this.capitalize(this.englishNumber(baht)) + ' Baht';
    if (!satang) return text + ' Only';
    return text + ' and ' + this.englishNumber(satang) + ' Satang';
  }

  private englishNumber(value: number): string {
    if (value < 1000) return this.englishGroup(value);

    const groups = [];
    let rest = value;
    while (rest > 0) {
      groups.push(rest % 1000);
      rest = Math.floor(rest / 1000);
    }

    const words: string[] = [];
    for (let i = groups.length - 1; i >= 0; i--) {
      if (groups[i] === 0) continue;
      words.push(this.englishGroup(groups[i]) + (this.enScale[i] || ''));
    }
    return words.join(' ');
  }

  // อ่านเลข 0-999
  private englishGroup(value: number): string {
    if (value < 20) return this.enNum[value];
    if (value < 100) {
      const tens = this.enTens[Math.floor(value / 10)];
      const ones = value % 10;
      return ones ? `${tens}-${this.enNum[ones]}` : tens;
    }
    const hundred = `${this.enNum[Math.floor(value / 100)]} hundred`;
    const rest = value % 100;
    return rest ? `${hundred} ${this.englishGroup(rest)}` : hundred;
  }

  private capitalize(text: string): string {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
  }

  private transformArray(array: any) {

    return this.chunkArray(array, 6).map((chunk, chunkIndex) => {

      const chunkResult = [];
      if (chunkIndex > 0) {
        chunkResult.push('ล้าน');
      }

      chunk.forEach((num: any, index: any) => {
        chunk[index + 1]
        if (num === 0 && chunk[index + 1] !== undefined) {
          return;
        }

        if (num === 1 && index === 0 && chunk.length > 1) {
          chunkResult.push('เอ็ด');
          return;
        }

        if (num === 1 && index === 1) {
          chunkResult.push(this.thaiUnit[index]);
          return;
        }

        if (num === 2 && index === 1) {
          chunkResult.push('ยี่' + this.thaiUnit[index]);
          return;
        }

        if (num === 0 && index !== 0) {
          return;
        }

        chunkResult.push(this.thaiNum[num] + this.thaiUnit[index]);
      });

      return chunkResult.reverse().join('');
    });
  }

  private chunkArray(myArray: any, chunk_size: any) {
    const results = [];
    while (myArray.length) {
      results.push(myArray.splice(0, chunk_size));
    }
    return results;
  }

}
